module.exports = __webpack_public_path__ + "img/al.daf0c837.svg";